import script from "./esNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./esNotification.vue?vue&type=script&setup=true&lang=ts"

import "./esNotification.vue?vue&type=style&index=0&id=24ec64d7&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24ec64d7"]])

export default __exports__